import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  ShopSellerBatchFileModel,
  ShopSellerBatchInfoModel,
  ShopSellerBatchModel
} from '../../models/shop-seller/shop-seller-batch.model';
import {Pageable} from '../../models/common/pageable.model';
import {ShopSellerListFilterModel, ShopSellerListItem} from '../../models/shop-seller/shop-seller.model';

@Injectable({
  providedIn: 'root'
})
export class ShopSellerBatchService {

  private readonly baseUrl = `${environment.backend.url}/api/shop-seller/v1`;

  constructor(private readonly http: HttpClient) {
  }

  getPastBatches(page: number = 0, size: number = 10): Observable<Pageable<ShopSellerBatchModel>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', size.toString());
    return this.http.get<Pageable<ShopSellerBatchModel>>(`${this.baseUrl}/batches`, { params });
  }

  getFiles(): Observable<ShopSellerBatchFileModel[]> {
    return this.http.get<ShopSellerBatchFileModel[]>(`${this.baseUrl}/files`);
  }

  getBatch(id: string, page: number = 0, pageSize: number = 10): Observable<ShopSellerBatchInfoModel> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    return this.http.get<ShopSellerBatchInfoModel>(`${this.baseUrl}/batch/${id}`, { params });
  }
}
